import { focus } from '../../helpers'
import { StyleFn } from '..'

export const Link: StyleFn = (theme) => {
  const {
    color,
    font,
    opacity,
    size: { spacing },
  } = theme
  const { focusWithPseudo } = focus(theme)

  const colors =
    color.type === 'light'
      ? {
          color: color.palette.primaryblue['60'],
          '&:hover': { color: color.palette.primaryblue['80'] },
          '&:active': { color: color.palette.primaryblue['90'] },
          '&:visited': { color: color.palette.purple['50'] },
        }
      : {
          color: color.palette.white,
          '&:hover': { color: color.palette.coolgrey['20'] },
          '&:active': { color: color.palette.coolgrey['30'] },
          '&:visited': { color: color.palette.purple['30'] },
        }

  return {
    root: {
      extend: [colors, focusWithPseudo()],
      cursor: 'pointer',
      textDecoration: 'none',
      fontFamily: 'inherit',
      // disable the focus ring for mouse, touch and keyboard users
      outline: 0,
      display: 'inline-flex',
      boxSizing: 'border-box',
      position: 'relative',
      fontWeight: font.weight.regular,
      fontSize: font.size.medium,
      lineHeight: font.lineheight.xxsmall,
      padding: `calc(${spacing[2]} + 1px) ${spacing[8]}`,
      borderRadius: 3,
    },
    _xsmall: {
      fontSize: font.size.xsmall,
      lineHeight: font.lineheight.xxsmall,
      padding: `calc(${spacing[2]} + 1px) ${spacing[4]}`,
    },
    _small: {
      fontSize: font.size.small,
      lineHeight: font.lineheight.xxsmall,
      padding: `calc(${spacing[2]} + 1px) ${spacing[8]}`,
    },
    _medium: {},
    _large: {
      fontSize: font.size.large,
      lineHeight: font.lineheight.medium,
      padding: `calc(${spacing[4]} - 1px) ${spacing[8]}`,
    },
    _underlined: {
      textDecoration: 'underline',
    },
    _inline: {
      '&$_inline': {
        border: 0,
        padding: `calc(${spacing[2]} + 1px) 0`,
      },
    },
    _disabled: {
      opacity: opacity.disabled,
      pointerEvents: 'none',
    },
  }
}
